import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);
const PlantContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const t = localStorage.getItem("ergoniq_token");
    const u = localStorage.getItem("ergoniq_user");
    return t && u ? JSON.parse(u) : null;
  });

  const login = async (username, password) => {
    const r = await api.post("/auth/login", { username, password });
    localStorage.setItem("ergoniq_token", r.data.token);
    localStorage.setItem("ergoniq_user", JSON.stringify({ username: r.data.username, role: r.data.role }));
    setUser({ username: r.data.username, role: r.data.role });
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("ergoniq_token");
    localStorage.removeItem("ergoniq_user");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function PlantProvider({ children }) {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchState = useCallback(async () => {
    try {
      const r = await api.get("/plant/state");
      setState(r.data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchState();
    const interval = setInterval(fetchState, 3000);
    return () => clearInterval(interval);
  }, [fetchState]);

  return (
    <PlantContext.Provider value={{ state, loading, error, refresh: fetchState }}>
      {children}
    </PlantContext.Provider>
  );
}

export const usePlant = () => useContext(PlantContext);
